import { LazyBakedManifestStore } from './lazyBakedManifest';

/** Re-key a baked-asset glob by filename without its JSON or WebP extension. */
export function byBaseName<T>(glob: Record<string, T>): Map<string, T> {
  const out = new Map<string, T>();
  for (const [path, value] of Object.entries(glob)) {
    const file = path.slice(path.lastIndexOf('/') + 1).replace(/\.(json|webp)$/, '');
    out.set(file, value);
  }
  return out;
}

// One shared URL index for every renderer that can request baked mobile art.
// The JSON and WebP payloads remain browser resources and are fetched only when used.
const mobileManifestUrls = import.meta.glob('../../assets/baked/mobiles/*.json', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

const mobileAtlasUrls = import.meta.glob('../../assets/baked/mobiles/*.webp', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

export const mobileManifestStore = new LazyBakedManifestStore(byBaseName(mobileManifestUrls));
export const mobileAtlasMap: ReadonlyMap<string, string> = byBaseName(mobileAtlasUrls);
